import { Metamodel } from '../base/model';
import { Activity, IAttribute, IViolation, LakehouseLinkedService, LinkedService, ModelConstants, ParameterConfig, ValueAdapter} from 'shell-models-lib';
import { WebExtensibleUtil } from 'app/shared/utils/web-extensible.util';

@Metamodel.model({
    name: ModelConstants.lakehouseMaintenanceActivity,
    referable: true,
    validator: LakehouseMaintenanceActivity.validateActivityProperties
})
export class LakehouseMaintenanceActivity extends Activity {
    
    @Metamodel.attribute({
        display: stringResources.ConnectionLabel,
        constraint: {
            required: true,
            validator: WebExtensibleUtil.validateConnection
        },
        reference: true,
        type: LakehouseLinkedService.MODEL
    })
    public lakehouseLinkedService?: LakehouseLinkedService;

    @Metamodel.attribute({
        reference: true,
        constraint: {
            required: true
        },
        type: LinkedService.MODEL
    })
    public artifactDmtsCredential?: LinkedService;

    public connector: string = 'lakehouse';

    public static readonly SCHEMA_NAME: IAttribute;
    public static readonly TABLE_NAME: IAttribute;

    public static readonly OPTIMIZE_ENABLED: IAttribute;
    public static readonly VORDER_ENABLED: IAttribute;
    public static readonly ZORDER_ENABLED: IAttribute;

    public static readonly VACUUM_ENABLED: IAttribute;
    public static readonly RETENTION_PERIOD: IAttribute;

    public static readonly WAIT_ON_COMPLETION: IAttribute;

    @Metamodel.attribute({
        association: 'SCHEMA_NAME',
        templatable: true
    })
    public schema: string = '';

    @Metamodel.attribute({
        association: 'TABLE_NAME',
        templatable: true,
        constraint: {
            required: true
        }
    })
    public table: string = '';

    @Metamodel.attribute({
        association: 'OPTIMIZE_ENABLED',
        templatable: true
    })
    public optimizeEnabled: boolean = false;

    @Metamodel.attribute({
        association: 'VORDER_ENABLED',
        templatable: true
    })
    public vOrderEnabled: boolean = false;

    @Metamodel.attribute({
        association: 'ZORDER_ENABLED',
        templatable: true
    })
    public zOrderEnabled: boolean = false;

    public zOrderColumns: ParameterConfig[] = [];

    @Metamodel.attribute({
        association: 'VACUUM_ENABLED',
        templatable: true
    })
    public vacuumEnabled: boolean = false;

    @Metamodel.attribute({
        association: 'RETENTION_PERIOD',
        templatable: true
    })
    public retentionPeriod: string;

    @Metamodel.attribute({
        association: 'WAIT_ON_COMPLETION',
        display: stringResources.ExecutePipelineActivityConfigurationWaitOnCompletion
    })
    public waitOnCompletion?: boolean = true;

    private static validateActivityProperties(activity: LakehouseMaintenanceActivity): IViolation[] | undefined {
        const violations: IViolation[] = [];
        // 1. Either optimize or vacuum must be enabled, otherwise the activity is a no-op
        const optimizeEnabled = activity.optimizeEnabled || ValueAdapter.isTemplated(activity, LakehouseMaintenanceActivity.OPTIMIZE_ENABLED);
        const vacuumEnabled = activity.vacuumEnabled || ValueAdapter.isTemplated(activity, LakehouseMaintenanceActivity.VACUUM_ENABLED);
        if (!optimizeEnabled && !vacuumEnabled) {
            violations.push({
                message: () => stringResources.LakehouseMaintenanceAtLeastOneOperation
            });
        }

        // 2. If zOrderEnabled is true, then at least one zOrder column must be specified
        const zOrderEnabled = activity.zOrderEnabled || ValueAdapter.isTemplated(activity, LakehouseMaintenanceActivity.ZORDER_ENABLED);
        if (zOrderEnabled) {
            if (!activity.zOrderColumns || activity.zOrderColumns.length === 0) {
                violations.push({   
                    message: () => stringResources.LakehouseMaintenanceZOrderColumnsRequired
                });
            }
        }

        // 3. If vacuumEnabled is true, retentionPeriod must be set and valid
        if (vacuumEnabled) {
            if (!ValueAdapter.isTemplated(activity, LakehouseMaintenanceActivity.RETENTION_PERIOD)) {
                const retentionPattern = /^(\d+:)?\d{1,2}:\d{1,2}:\d{1,2}$/;
                if (!retentionPattern.test(activity.retentionPeriod)) {
                    violations.push({
                        message: () => stringResources.LakehouseMaintenanceInvalidRetention
                    });
                }
            }
        }

        return violations;
    }
        
}